import {Hooks} from '@microfrontends/react-components'
import {FC, useContext, useMemo} from 'react'
import {month, monthEN} from '../../assets/constant'
import {IEvent} from '../../assets/types'
import {STCountdown, STDay, STDots, STTime, STTimeContent, STTimeWrapper} from './styles'
import AppContext from '../../../../context/AppContext'
import {ELanguage} from '@microfrontends/app-shell-v2'

interface ICountdownProps {
	event: IEvent
}

export const Countdown: FC<ICountdownProps> = ({ ...props }) => {
	const { times } = Hooks.useCountdown(props.event.endDate)
	const { languageCode, t } = useContext(AppContext)
	const formatTime = (time: number) => (time > 9 ? time : '0' + time)

	const days = useMemo(() => {
		const newDate = new Date(props.event.endDate)
		const days = newDate.getDate()
		const months = languageCode === ELanguage.EN ? monthEN[newDate.getMonth()] : month[newDate.getMonth()]

		return { days, months }
	}, [props.event.endDate])

	return (
		<STCountdown>
			<STDay>
				<p>{days.months}</p>
				<p>{days.days}</p>
			</STDay>
			<STTimeContent>
				<STTimeWrapper>
					<STTime>{formatTime(times.days)}</STTime>
					<STDots>:</STDots>
					<STTime>{formatTime(times.hours)}</STTime>
					<STDots>:</STDots>
					<STTime>{formatTime(times.hours)}</STTime>
					<STDots>:</STDots>
					<STTime>{formatTime(times.seconds)}</STTime>
				</STTimeWrapper>
				<p>{t('Coming soon')}</p>
			</STTimeContent>
		</STCountdown>
	)
}
